import type { ReporteEnMemoria } from '../services/reportesService';

/**
 * Borrador local de un reporte en proceso de envío. Protege al operador en
 * el campo: si pierde cobertura justo al enviar y la app se cierra o
 * recarga antes de que el envío se confirme, el reporte no se pierde — al
 * volver a abrir la app se le ofrece reintentar el mismo envío.
 *
 * Deliberadamente simple: no es una cola de sincronización en segundo plano
 * (esa capa existió antes como pwa/sync/syncManager.ts pero nunca se conectó
 * al flujo real de envío, y se eliminó por completo el 2026-09-07 — quedará
 * rediseñada desde cero cuando se necesite de verdad). Esto solo protege la
 * ventana entre "toqué Enviar" y "el servidor confirmó que lo recibió".
 */

const DRAFT_KEY = 'mava_reporte_borrador';

export interface ReporteDraft {
  reporte: ReporteEnMemoria;
  empresaId: number;
  guardadoEn: string; // ISO timestamp
}

export function guardarBorrador(reporte: ReporteEnMemoria, empresaId: number): void {
  try {
    const draft: ReporteDraft = {
      reporte,
      empresaId,
      guardadoEn: new Date().toISOString(),
    };
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch (error) {
    // localStorage lleno o no disponible (modo privado, etc.) — no bloquear
    // el envío por esto, solo perdemos la protección de borrador.
    console.warn('No se pudo guardar el borrador del reporte:', error);
  }
}

export function obtenerBorrador(): ReporteDraft | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function limpiarBorrador(): void {
  localStorage.removeItem(DRAFT_KEY);
}
